// @ts-nocheck
import ActionTypes from "../constants/actions";

const initialState = {
  error: null, // last occured error
  token: null,
  profile: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ROUTER_STATE_CHANGE:
      return {
        ...state,
        error: null
      };
    case ActionTypes.LOGIN_SUCCESS:
      console.log("LOGIN_SUCCESS: ", action);
      return {
        ...state,
        error: null,
        token: action.token
      };
    case ActionTypes.SIGNUP_FAILURE:
    case ActionTypes.LOGIN_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case ActionTypes.LOGOUT:
      return { ...initialState };
    case ActionTypes.LOGOUT_PROFILE_SUCCESS:
      return { ...initialState };

    case ActionTypes.SAVE_PROFILE:
    case ActionTypes.SAVE_PROFILE_SUCCESS:
    case ActionTypes.FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        profile: { ...state.profile, ...action.user },
        // token: action.token,
        error: null
      };
    default:
      return state;
  }
};
